import FakeLink from "@/components/FakeLink/FakeLink";
import { ProductBy } from "@/pages/dashboard/hooks/useProductImpact";
import { ImpactMetric } from "@/pages/dashboard/utils/types";
import { ReactNode } from "react";
import { useSearchParams } from "react-router-dom";
import {
  PRODUCT_DRAWER_URL_BY,
  PRODUCT_DRAWER_URL_PRODUCT_ID,
  PRODUCT_DRAWER_URL_TYPE,
} from "./ProductDrawer";

export interface ProductDrawerActionProps {
  children: ReactNode;
  productId: number;
  metric?: ImpactMetric;
  by?: ProductBy;
  className?: string;
  disabled?: boolean;
}

export default function ProductDrawerAction({
  children,
  productId,
  metric,
  className,
  by = "single",
  disabled = false,
}: ProductDrawerActionProps) {
  const [, setSearchParams] = useSearchParams();

  const onClick = () => {
    if (disabled) return;
    setSearchParams(
      (searchParams) => {
        searchParams.set(PRODUCT_DRAWER_URL_PRODUCT_ID, String(productId));
        searchParams.set(PRODUCT_DRAWER_URL_BY, by);
        if (metric) searchParams.set(PRODUCT_DRAWER_URL_TYPE, metric.key);
        return searchParams;
      },
      { replace: true }
    );
  };

  return (
    <FakeLink
      className={className}
      onClick={onClick}
    >
      {children}
    </FakeLink>
  );
}
